<button appButton [name]="name" [location]="location" [color]="color" spacing="full" [hasIcon]="!!icon || !!imageUrl"
  (click)="onClick.emit($event)" [height]="height" [class.disabled]="disabled" [shape]="shape" [weight]="weight"
  [spacing]="fullWidth ? 'full' : ''" [alignment]="fullWidth ? 'left' : 'center'" [class]="buttonClass">
  <app-svg *ngIf="!!icon" [attr.color]="iconColor" src="/assets/icons/{{icon}}.svg"></app-svg>
  <img [src]="imageUrl" *ngIf="imageUrl" alt="">
  <span class="button-span" [class.overflow-visible]="!!shortcut">
    <ng-content></ng-content>
    <ng-container *ngIf="shortcut">
      <div class="shortcut" *onlyForScreens="['desktop']">{{shortcut}}</div>
    </ng-container>
  </span>
  <ng-content select="[post]"></ng-content>
</button>
